<template>
  <div class="buy-container" v-if="isInit">
      <page-title :title="gettext('券包')"></page-title>
      <main>
        <div class="little-title">{{gettext('应付金额')}}</div>
        <div class="amount">
          {{priceDisplay}}
        </div>
      </main>
      <footer>
        <div class="payment">
          <span class="label">{{gettext('支付方式')}}</span>
          <div class="select-payment" @click="selectPayment(selectedCard.card_index)">
            <div v-if="hasSelectedCard" class="has-payment">
              <img :src="selectedCard.card_org" class="ic-card" alt="">
              <span class="card-num">{{selectedCard.card_suffix | cardFilter}}</span>
            </div>
            <span v-else class="no-payment">{{gettext('请选择支付方式')}}</span>
            <i class="icon-right"></i>
          </div>
        </div>
        <div class="btn-wrap">
          <rich-button 
            :loading="loading" 
            :disabled="!hasSelectedCard"
            @click.native="goPay()"
          >
            {{gettext('购买')}}
          </rich-button>
        </div>
      </footer>
      <!-- <payment v-if="changePayment" @selected="handleSelected" @cancel="handleCancel"></payment> -->
  </div>
</template>
<script>
import PageTitle from './modules/page-title'
import { closePage } from '@/common/js/bridge'
import payment from './payment'
import { mapGetters, mapActions } from 'vuex'
import { couponPaymethodPopupCk, couponPayResultCk } from '@/page/newCouponsCenter/track'
import loginMixin from '@/common/mixin/login'

export default {
  name: 'buy',
  mixins: [loginMixin],
  components: {
    PageTitle,
    payment
  },
  data () {
    return {
      isInit: false,
      orderId: '',
      priceDisplay: '',
      position: {},
      loading: false,
      tid: null,
      queryCount: 0,
      from: 2// 埋点支付来源1卡片、2购买详情页
    }
  },
  computed: {
    ...mapGetters(['globalParams', 'selectedCard']),
    extraInfoList () {
      return this.$store.state.extraInfoList
    },
    hasSelectedCard () {
      return Object.keys(this.selectedCard).length > 0
    }
  },
  filters: {
    // 取卡号后4位
    cardFilter (card) {
      return String(card).slice(-4) || ''
    }
  },
  async created () {
    this.getTokenToLogin(this.getInit)
  },
  methods: {
    ...mapActions({
      createOrder: 'createOrder',
      getPayInfo: 'getPayInfo',
      setPayment: 'setPayment',
      queryOrderStatus: 'queryOrderStatus',
      getGlobalInfo: 'getGlobalInfo'
    }),
    getInit () {
      this.priceDisplay = decodeURIComponent(this.$route.query.priceDisplay) || ''
      this.getGlobalInfo().then((data) => {
        this.requestPayInfo()
      })
      this.isInit = true
    },
    polling (fn, internal = 10000) {
      const me = this
      const poll = () => {
        me.tid = window.setInterval(() => {
          fn.call(me)
        }, internal)
      }
      poll()
    },
    clearPolling (tid) {
      window.clearInterval(tid)
    },
    async goPay () {
      const me = this
      try {
        this.loading = true
        // 创建订单
        const res = await this.createOrder({
          ...this.globalParams,
          productId: this.params.productId,
          price: this.params.price,
          payChannel: {
            cardIndex: this.selectedCard.card_index,
            channelId: this.selectedCard.channelID,
            cardOrg: this.selectedCard.card_org
          }
        })
        if (res && res.errno === 0 && res.data) {
          me.polling(async () => {
            if (me.queryCount <= 5) {
              const orderDetail = await me.queryOrderStatus({
                ...this.globalParams,
                orderId: res.data.orderId
              })
              if (orderDetail && orderDetail.errno === 0 && orderDetail.data) {
                me.queryCount += 1
                // payStatus: 0 => 待支付 1 => 已支付 2 => 已退款
                if (orderDetail.data.payStatus === 1) {
                  couponPayResultCk({
                    from: this.from,
                    result_status: 1 // 支付结果埋点，1成功、0失败
                  })
                  me.loading = false
                  // 支付成功之后弹窗提示，点击去使用关闭webview
                  me.$createDialog({
                    type: 'alert',
                    icon: 'richic-right',
                    content: me.gettext('支付成功'),
                    showClose: true,
                    confirmBtn: {
                      text: me.gettext('去预订食物'),
                      active: true,
                      disabled: false,
                      href: 'javascript:;'
                    },
                    onConfirm: () => {
                      closePage()
                    }
                  }).show()
                }
              } else {
                me.clearPolling(me.tid) // 清除轮询
                me.creatErrorToast(orderDetail.errmsg)
                me.loading = false
                couponPayResultCk({
                  from: this.from,
                  result_status: 0
                })
              }
            } else {
              me.clearPolling(me.tid)
              me.creatErrorToast(me.gettext('支付超时！'))
              me.loading = false
              couponPayResultCk({
                from: this.from,
                result_status: 0
              })
            }
          }, 3000)
        } else {
          me.creatErrorToast(res.errmsg)
          me.loading = false
          couponPayResultCk({
            from: this.from,
            result_status: 0
          })
        }
      } catch (e) {
        me.creatErrorToast()
        me.loading = false
        couponPayResultCk({
          from: this.from,
          result_status: 0
        })
      }
    },
    async requestPayInfo () {
      // 获取卡信息
      await this.getPayInfo({
        ...this.globalParams
      })
      if (Object.keys(this.selectedCard).length === 0) {
        if (this.extraInfoList.length > 0) {
          // 默认选择第一张卡
          this.setPayment(this.extraInfoList[0])
        }
      }
    },
    selectPayment () {
      couponPaymethodPopupCk({from: this.from})
      this.$router.push({
        name: 'payment'
      })
    },
    creatErrorToast (errmsg = '', defaultMsg = this.gettext('网络繁忙，请稍后再试')) {
      const errorToast = this.$createToast({
        txt: errmsg || defaultMsg,
        time: 2000,
        mask: false,
        type: 'error'
      })
      errorToast.show()
    },
    creatSuccessToast (msg = '', defaultMag = '') {
      const toast = this.$createToast({
        txt: msg || defaultMag,
        time: 2000,
        mask: false,
        type: 'correct'
      })
      toast.show()
    }
  },
  destroyed () {
    this.clearPolling(this.tid) // 清除轮询
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/main";
.buy-container {
  background: #fff;
  height: 100%;
  main {
    margin: 25.1% auto 0;
    color: #333;
    text-align: center;
    .little-title {
      font-family: Aspira Medium;
      font-size: 36px;
      line-height: 60px;  
    }
    .amount {
      margin-top: 14px;
      font-family: Aspira Medium;
      font-size: 56px;
      font-weight: 500;
      line-height: 60px;
    }
  }
  footer {
    position: fixed;
    width: 100%;
    bottom: 52px;
    .payment {
      margin-bottom: 67px;
      padding: 0 28px 0 40px
      height: 54px;
      line-height: 54px;
      display: flex;
      justify-content: space-between;
      color: #333;
      .label {
        font-family: Aspira Regular;
        font-size: 32px;
      }
      .select-payment {
        font-family: Aspira Regular;
        display: flex;
        align-items: center;
        // span {
        //   display: flex;
        //   align-items: center;
        // }
        .has-payment {
          display: flex;
          align-items: center;
        }
        .ic-card {
          width: 87px;
          height: 54px;
          border-radius: 3px;
        }
        .card-num {
          margin-left: 17px;
          font-family: Aspira Medium;
          font-size: 36px;
          color: #333;
        }
        .no-payment {
          display: flex;
          align-items: center;
          font-size: 28px;
          color: #CCC;
        }
        .icon-right {
          margin-left: 8px;
          display: inline-block;
          vertical-align: top;
          width: 24px;
          height: 24px;
          background-image: url('~@/assets/images/c/icon-right.png');
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
        }
      }
    }
    .btn-wrap {
      margin: 0 40px 0;
      height: 90px;
      line-height: 90px;
    }
  }
}
</style>